import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core'
import DazzedParagraph11 from 'components/common/text/DazzedParagraph11'
import OralScoreTag from '../Tags/OralScoreTag'
import { OralScoreCategories } from 'consts/oralScoreConsts'
import OralScoreFrozenIndicator from '../OralScoreFrozenIndicator'

const OralStatus = ({ oralScores = {}, rawOralScores = {} }) => {
  const { t } = useTranslation()

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <DazzedParagraph11 thickness="bold" color={'var(--text-color-62)'}>
          {t(`pages.patients.selectedPatient.timelineV2.miniTimeline.scanTooltip.oralScore`)}
        </DazzedParagraph11>
      </Grid>
      <Grid item>
        <Grid container direction="column" spacing={0}>
          <Grid item>
            <OralScoreTag
              scoreValue={oralScores.hygieneScore}
              category={OralScoreCategories.Hygiene}
              withBackground
              withIcon
              boldLabel
            />
          </Grid>
          <Grid item>
            <OralScoreFrozenIndicator oralScores={rawOralScores} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <OralScoreTag
          scoreValue={oralScores.perioRisk}
          category={OralScoreCategories.PerioRisk}
          withBackground={false}
          withIcon={false}
          boldLabel={false}
        />
        <OralScoreFrozenIndicator oralScores={rawOralScores} scoreKey="periodontal_risk" />
      </Grid>
      <Grid item>
        <OralScoreTag
          scoreValue={oralScores.dentalRisk}
          category={OralScoreCategories.DentalRisk}
          withBackground={false}
          withIcon={false}
          boldLabel={false}
        />
        <OralScoreFrozenIndicator oralScores={rawOralScores} scoreKey="dental_risk" />
      </Grid>
    </Grid>
  )
}

export default OralStatus
